import { LocaleProvider, QueryClientProvider } from '@systemeio/file-manager'
import { TipTapLocaleProvider } from '@systemeio/tip-tap'
import { LocaleEnum, SharedLocaleProvider, getLanguageCodeByLocale } from '@systemeio/ui'
import { HelpBots } from 'help-bots'
import Head from 'next/head'
import Router, { useRouter } from 'next/router'
import React from 'react'
import Header from 'shared/components/header'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import useUser from 'shared/hooks/use-user'
import { useEmailStatusNotification } from 'shared/notifications/hooks/use-email-status-notification'
import { usePaymentNotification } from 'shared/notifications/hooks/use-payment-notification'
import { Snow } from './snow'
import { useChristmas } from './snow/use-christmas'

const disabledPageRoute = '/disabled'

function DashboardLayout({ children, browserTabTitle }: React.PropsWithChildren<any>) {
  useEmailStatusNotification()
  usePaymentNotification()

  const christmasFeatureIsOn = useChristmas()

  const { t } = useLocoTranslation()

  const { pathname } = useRouter()

  const { isDisabled, user } = useUser()

  if (isDisabled && pathname !== disabledPageRoute) {
    Router.replace(disabledPageRoute)
  }

  const locale = user?.dashboardLocale ?? LocaleEnum.ENGLISH
  const languageCode = getLanguageCodeByLocale(locale)

  return (
    <>
      <HelpBots />
      <Head>
        <title>{t(browserTabTitle)}</title>
      </Head>
      <div>
        <Header />
        <div className="px-4 sm:px-6 md:px-14">
          <SharedLocaleProvider locale={locale}>
            <LocaleProvider languageCode={languageCode}>
              <TipTapLocaleProvider languageCode={languageCode}>
                <QueryClientProvider>
                  <main className="py-5">{children}</main>
                </QueryClientProvider>
              </TipTapLocaleProvider>
            </LocaleProvider>
          </SharedLocaleProvider>
        </div>
      </div>
      {christmasFeatureIsOn && <Snow />}
    </>
  )
}

export default DashboardLayout
